import { fg } from '@atlassian/jira-feature-gating';

const UserPickerGuestLozengeRelayprovider = {
	get(): boolean {
		return fg('user_picker_guest_lozenges');
	},
};

export default UserPickerGuestLozengeRelayprovider;
